// import axios from "axios";
import { api, authorizationKey, BASE_URL } from "./BASE_URL";

export const fetchContacts = async (currentPage) => {
  try {
    const response = await api.get(
      `${BASE_URL}/admin/contacts?page=${currentPage}`,
      {
        headers: {
          Authorization: authorizationKey,
        },
      }
    );
    // const foramttedResponse = addIsChecked(response.data);
    return response.data;
  } catch (err) {
    if (err.message === "canceled") {
      return;
    }
    console.error("Error fetching contacts:", err);
    throw err;
  }
};

export const postNewContact = async (contact) => {
  try {
    const response = await api.post(`${BASE_URL}/admin/contacts`, contact, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error posting new contact", err);
    throw err;
  }
};

export const deleteContact = async (id) => {
  try {
    const response = await api.delete(`${BASE_URL}/admin/contacts/${id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error(`Error deleting contact with ID ${id}:`, err);
    throw err;
  }
};
export const deleteCheckedContacts = async (contacts) => {
  const requests = contacts.map((contact) =>
    api.delete(`${BASE_URL}/admin/contacts/${contact.id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    })
  );

  try {
    await Promise.all(requests);
  } catch (error) {
    throw new Error("Some contacts could not be deleted.");
  }

  return contacts;
};

export const getConatctData = async (id) => {
  try {
    const response = await api.get(`${BASE_URL}/admin/contacts/${id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error(
      `There was an error getting contact's data from the server: ${err}`
    );
    throw err;
  }
};
export const updateContact = async ({ payload, contactId }) => {
  try {
    const response = await api.put(
      `${BASE_URL}/admin/contacts/${contactId}`,
      payload,
      {
        headers: {
          Authorization: authorizationKey,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error updating contact: ", err);
    throw err;
  }
};
